import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { Flex } from "@similarweb/ui-components/foundations";

export const StyledTableContainerFlex = styled(Flex)`
    background: ${colorsPalettes.carbon[0]};
    border-radius: 6px;
    border: 1px solid ${colorsPalettes.carbon[50]};
    padding: 16px;
    overflow-x: auto;
`;
